import React from "react"
import types from "prop-types"
import { useAnsweredFormOverviewContext } from "contexts/AnsweredFormOverviewContext"
import Answer from "./Answer"

const UsersAnswer = ({ rawAnswer = [] }) => {
  const { user_ids: userIds = [] } = rawAnswer
  const { usersWithIds } = useAnsweredFormOverviewContext()
  const users = usersWithIds(userIds)

  const userNames = users.map((user) => user.fullName).join(", ")

  return (
    <Answer rawAnswer={userNames} />
  )
}

UsersAnswer.propTypes = {
  rawAnswer: types.shape({
    user_ids: types.arrayOf(types.number),
  }),
}

export default UsersAnswer
